import { Component } from '@ecs/Component';

export class Damage implements Component {
  readonly type = 'Damage';

  constructor(
    public amount: number = 1
  ) {}
}